import { Box, Stack } from '@hover/blueprint';
import { Button } from '@hover/blueprint/brand';
import React, { useState } from 'react';
import { Link } from 'gatsby';
import ArrowButton from '../../ui/ArrowButton';
import { DownloadAppModal } from '../../common';

const InsuranceResolutionButtons: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <Stack
      spacing={500}
      my={700}
      direction={{ base: 'column', desktop: 'row' }}
      alignItems="center"
    >
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Box flexDir={{ base: 'column', tablet: 'row' }} mt={800}>
        <Button
          onClick={toggleModal}
          colorScheme="primary"
          variant="solid"
          whiteSpace="nowrap"
          mb={{ base: 500, desktop: 0 }}
          w={{ base: '100%', tablet: 'auto' }}
        >
          Start measuring in minutes
        </Button>
        <ArrowButton
          flex={0}
          variant="minimal"
          whiteSpace="nowrap"
          ml={500}
          as={Link}
          to={`${process.env.GATSBY_V2_PREFIX}/pricing`}
        >
          Go to pricing
        </ArrowButton>
      </Box>
    </Stack>
  );
};

export default InsuranceResolutionButtons;
